<template>
  <div
    @contextmenu="selectComponentDEV($event, schema.model)"
    :class="['download-pdf', getSelectedDEV && 'dev-selected-component', downlodView && 'downlodView']"
  >
    <v-container ref="content" fluid class="content-markdown" v-if="markdown" v-html="markdown"></v-container>

    <v-btn
      v-if="'downloadPdf' in schema && schema.downloadPdf.download"
      fab
      v-bind="schema.attributesButtonPdf"
      class="button-downlod-pdf"
      @click="download()"
    >
      <v-icon>far fa-file-pdf</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';

import { Remarkable } from 'remarkable';
import hljs from 'highlight.js';

import jsPDF from 'jspdf';

export default {
  mixins: [abstractField, devComponentMixin],

  data() {
    return {
      markdown: '',
      downlodView: false
    };
  },

  created() {
    if (!this.value && this.schema.content) {
      this.value = this.schema.content;
    }

    this.renderMarkdown(this.value);
  },

  methods: {
    download() {
      const doc = new jsPDF({
        unit: 'pt',
        orientation: 'p',
        format: 'a4',
        compress: true
      });
      this.downlodView = true;
      const contentHtml = this.$refs.content;
      doc.nameDownload = this.schema.downloadPdf.name || 'arquivo-sistema';

      doc
        .html(contentHtml, {
          callback: function(doc) {
            doc.save(doc.nameDownload);
          },
          x: 10,
          y: 10,
          margin: 10
        })
        .then(data => {
          this.downlodView = false;
        });
    },

    renderMarkdown(template) {
      hljs.initHighlightingOnLoad();

      let md = new Remarkable({
        html: false,
        xhtmlOut: true,
        breaks: true,
        langPrefix: 'language-',
        linkTarget: '_blank',
        typographer: true,
        quotes: '“”‘’',

        highlight: function(str, lang) {
          if (lang && hljs.getLanguage(lang)) {
            try {
              return hljs.highlight(lang, str).value;
            } catch (__) {}
          }

          try {
            return hljs.highlightAuto(str).value;
          } catch (__) {}

          return '';
        }
      });

      this.markdown = md.render(template);
    }
  }
};
</script>

<style lang="scss">
.downlodView {
  display: none;
  &.download-pdf,
  .content-markdown {
    max-width: 550px;
  }
}

.content-markdown {
  span {
    word-break: break-word;
    white-space: pre-line;
  }
}

.layout-container {
  position: unset !important;
  background: none !important;
  display: unset !important;

  position: absolute;
  top: 0;
}

.download-pdf {
  position: relative;
  top: 0px;
  height: 100%;
  display: flex;

  ul li {
    list-style-type: circle;
  }

  .button-downlod-pdf {
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 10;

    animation: opacity-end 0.5s forwards;
  }

  &:hover {
    &:before {
      position: absolute;
      content: '';
      width: 100%;
      height: 100%;
    }

    .button-downlod-pdf {
      animation: opacity-init 1s forwards;
    }
  }
}

@keyframes opacity-init {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes opacity-end {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
</style>
